import { StageId, StageConfig } from "../types";
import { STAGE_CONFIGS, STAGE_THRESHOLDS, STAGE_ORDER } from "../config";

/** 難易度管理（スコア→ステージ、降格なし） */
export class DifficultySystem {
  /** スコアからステージを判定 */
  getStageByScore(score: number): StageId {
    let result: StageId = "S1";
    for (const threshold of STAGE_THRESHOLDS) {
      if (score >= threshold.score) {
        result = threshold.stage;
      }
    }
    return result;
  }

  /** 降格なし: 現在のステージと新ステージの大きい方を返す */
  ensureNoDowngrade(current: StageId, candidate: StageId): StageId {
    const currentIdx = STAGE_ORDER.indexOf(current);
    const candidateIdx = STAGE_ORDER.indexOf(candidate);
    return candidateIdx >= currentIdx ? candidate : current;
  }

  /** ステージ設定を取得 */
  getConfig(stage: StageId): StageConfig {
    return STAGE_CONFIGS[stage];
  }

  /** 現在ステージの進捗（0.0〜1.0）と次の閾値を返す */
  getProgress(stage: StageId, score: number): { ratio: number; nextScore: number } {
    const stageIdx = STAGE_ORDER.indexOf(stage);

    // 最終ステージなら進捗100%
    if (stageIdx >= STAGE_ORDER.length - 1) {
      return { ratio: 1.0, nextScore: 0 };
    }

    // 現在ステージの下限スコア
    const currentThreshold = STAGE_THRESHOLDS.find((t) => t.stage === stage);
    const currentMin = currentThreshold ? currentThreshold.score : 0;

    // 次ステージの閾値
    const nextThreshold = STAGE_THRESHOLDS.find(
      (t) => t.stage === STAGE_ORDER[stageIdx + 1]
    );
    const nextMin = nextThreshold ? nextThreshold.score : currentMin;

    const range = nextMin - currentMin;
    if (range <= 0) return { ratio: 1.0, nextScore: nextMin };

    const progress = Math.max(0, Math.min(1, (score - currentMin) / range));
    return { ratio: progress, nextScore: nextMin };
  }
}
